import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import Newsletter from "../components/NewsLetter";
import Developer from "../pages/Developer";

const MainLayout = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const isHome = pathname === "/";
  const isWishlist = pathname === "/wishlist";

  const hideShippingRoutes = [
    "/checkout",
    "/contact",
    "/account",
    "/login",
    "/signup",
    "/register",
    "/help-center",
    "/live-chat",
    "/order-confirm",
    "/privacy-policy",
    "/refund-policy",
    "/returns",
    "/shipping-delivery",
    "/terms-condition",
    "/developer",
  ];

  const hideShipping = hideShippingRoutes.includes(pathname);

  return (
    <>
      <ColorInit color={false} />

      <ScrollToTop smooth color="#299e60" />

      <Preloader />

      <HeaderOne
        showCategories={!isWishlist}
        showSearchBar={!isWishlist}
      />

      <Outlet />

      {!hideShipping && <ShippingOne />}

      {isHome && <Newsletter />}

      <FooterOne />

      {!isHome && <BottomFooter />}
    </>
  );
};

export default MainLayout;